import React, {useContext} from "react";
// @ts-ignore
import {useParams, Link} from "react-router-dom";

import {RankingsAndLevelsContext} from "../../../contexts/RankingsAndLevelsContext";
import {FlexedDiv, RankingsNavbarDiv, RankingsTitleDiv, RowDivF1} from "../../styledComponents/CustomStyledComponents";
import BackComponent from "../../backComponent/BackComponent";
import Colors from "../../../assets/colors/Colors";
import Separator from "./Separator";
import {useTranslation} from "react-i18next";

const TierNavbar: React.FC<{backRoute: string}> = ({backRoute }) => {
    let { yearCode, tierCode } = useParams();
    // @ts-ignore
    const { isLife } = useContext(RankingsAndLevelsContext);
    const { t } = useTranslation();
    const tierCodeFormatted = tierCode.replace('tier', 'Tier ');
    const color = isLife ? Colors.fontWhite: Colors.fontGray;

    return (
        <RankingsNavbarDiv>
            <RowDivF1>
                <div style={{flex: '1 0 auto'}}>
                    <BackComponent
                        backRoute={backRoute}
                        label={t('back')}
                        customStyle={{justifyContent: 'center', alignItems: 'center', display: 'flex'}}
                        backColor={color}
                    />
                </div>
                <div style={{flex: '1 0 auto'}}>
                    <Separator customStyle={{marginRight: 20, marginLeft: 20}} separatorColor={color}/>
                </div>
                <div style={{flex: '1 0 auto'}}>
                    <RankingsTitleDiv isLife={isLife}>{yearCode}</RankingsTitleDiv>
                </div>
                <div style={{flex: '1 0 auto'}}>
                    <Separator customStyle={{marginRight: 20, marginLeft: 20}} separatorColor={color}/>
                </div>
                <div style={{flex: '1 0 auto'}}>
                    <RankingsTitleDiv isLife={isLife}>{tierCodeFormatted}</RankingsTitleDiv>
                </div>
            </RowDivF1>
            <FlexedDiv flexValue={6}/>
        </RankingsNavbarDiv>
    )
};

export default TierNavbar;
